export const DEFAULT_VAR_PREFIX = "ui"
export const DEFAULT_LOCALE = "en-US"
export const DEFAULT_DIRECTION = "ltr"
